module.exports = __webpack_public_path__ + "static/img/profile-icon18.b840f25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon18.png
// module id = 2966
// module chunks = 1